import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { getAuth } from "firebase/auth";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import { IoDocument, IoEyeSharp } from "react-icons/io5";
import EcokazAfrica from "../../img/ecokaz_africa.png";
import Logo from "../../img/logo.png";
import {
  PDFDownloadLink,
  Document,
  StyleSheet,
  Page,
  View,
  Image,
  Text,
  Font,
} from "@react-pdf/renderer";

function Achats() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const auth = getAuth();
  const user = auth.currentUser;

  useEffect(() => {
    const fetchPayments = async () => {
      if (user) {
        const q = query(
          collection(db, "payments"),
          where("userId", "==", user.uid)
        );
        const querySnapshot = await getDocs(q);
        const paymentsData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setPayments(paymentsData);
        setLoading(false);
      }
    };

    fetchPayments();
  }, [user]);

  const formatDate = (seconds) => {
    const date = new Date(seconds * 1000);
    const options = { day: "numeric", month: "long", year: "numeric" };
    const dateString = date.toLocaleDateString("fr-FR", options);
    const timeString = date.toLocaleTimeString("fr-FR", {
      hour: "2-digit",
      minute: "2-digit",
    });
    return `${dateString} à ${timeString}`;
  };

  const formatHeure = (seconds) => {
    const date = new Date(seconds * 1000);
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const formatSimpleDate = (seconds) => {
    const date = new Date(seconds * 1000);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const showModal = (payment) => {
    setSelectedPayment(payment);
    document.getElementById("payment-modal").showModal();
  };

  const invoiceRef = useRef();

  Font.register({
    family: "Poppins",
    fonts: [
      { src: "/fonts/poppins-regular.ttf", fontWeight: 400 }, // Regular
      { src: "/fonts/poppins-bold.ttf", fontWeight: 700 }, // Bold
      { src: "/fonts/poppins-extrabold.ttf", fontWeight: 800 }, // ExtraBold
    ],
  });

  const styles = StyleSheet.create({
    page: {
      padding: 30,
      fontSize: 11,
      fontFamily: "Poppins",
    },
    header: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: 20,
    },
    logo: {
      width: 50,
      height: 50,
    },
    invoiceDetails: {
      textAlign: "right",
      flexDirection: "column",
      alignItems: "flex-end",
    },
    customerDetails: {
      marginBottom: 20,
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginBottom: 20,
    },
    tableHeader: {
      flexDirection: "row",
      borderBottom: "1px solid #000",
      backgroundColor: "#f0f0f0",
      padding: 5,
    },
    tableRow: {
      flexDirection: "row",
      borderBottom: "1px solid #ccc",
      padding: 5,
    },
    tableFooter: {
      flexDirection: "row",
      padding: 5,
    },
    tableCell: {
      paddingLeft: 5,
      paddingRight: 5,
      paddingTop: 2,
      paddingBottom: 2,
    },
    productDescription: {
      color: "gray",
      fontSize: 9,
    },
    rightAlignCell: {
      flex: 1,
      paddingLeft: 5,
      paddingRight: 5,
      paddingTop: 2,
      paddingBottom: 2,
      textAlign: "right",
    },
    colspanCell: {
      flex: 2,
      padding: 5,
    },
    total: {
      textAlign: "right",
      marginRight: 30,
      fontWeight: 800,
    },
    footer: {
      marginTop: 20,
      textAlign: "center",
    },

    col50: {
      width: "50%",
    },
    col15: {
      width: "15%",
    },
    col20: {
      width: "20%",
    },
    col65: {
      width: "65%",
    },
  });

  const InvoicePDF = () => (
    <Document>
      {selectedPayment && (
        <Page size="A4" style={styles.page}>
          <View style={styles.header}>
            <Image style={styles.logo} src={Logo} />
            <View style={styles.invoiceDetails}>
              <Text>Lallbahadoor Shastri road candos</Text>
              <Text style={{ color: "gray" }}>contact@ecokazafrica.com</Text>
              <Text style={{ color: "gray" }}>+23058555814</Text>
            </View>
          </View>
          <View style={styles.header}>
            <View style={styles.customerDetails}>
              <Text style={{ fontWeight: 800, fontSize: 18 }}>Facturer à:</Text>
              <Text>{selectedPayment?.address_ship}</Text>
              <Text>
                {selectedPayment?.city_ship} {selectedPayment?.postal_ship},{" "}
                {selectedPayment?.country_ship}
              </Text>
              <Text>elnicolas787@gmail.com</Text>
            </View>
            <View style={[styles.invoiceDetails, { marginTop: 20 }]}>
              <Text>N° facture: ECO-{selectedPayment?.num_facture}</Text>
              <Text>
                Date de facture:{" "}
                {formatSimpleDate(selectedPayment?.createdAt.seconds)}
              </Text>
              <Text>
                Heure de facture:{" "}
                {formatHeure(selectedPayment?.createdAt.seconds)}
              </Text>
            </View>
          </View>

          <View style={styles.table}>
            <View style={styles.tableHeader}>
              <Text
                style={[styles.tableCell, styles.col50, { fontWeight: 800 }]}
              >
                Produits
              </Text>
              <Text
                style={[styles.tableCell, styles.col15, { fontWeight: 800 }]}
              >
                Quantités
              </Text>
              <Text
                style={[
                  styles.rightAlignCell,
                  styles.col15,
                  { fontWeight: 800 },
                ]}
              >
                Prix
              </Text>
              <Text
                style={[
                  styles.rightAlignCell,
                  styles.col20,
                  { fontWeight: 800 },
                ]}
              >
                Montant
              </Text>
            </View>
            {selectedPayment?.items.length > 0 &&
              selectedPayment?.items.map((item) => (
                <View style={[styles.tableRow]}>
                  <Text style={[styles.tableCell, styles.col50]}>
                    {item.title} {"\n"}
                    <Text style={styles.productDescription}>{item.mesure}</Text>
                  </Text>
                  <Text
                    style={[
                      styles.tableCell,
                      styles.col15,
                      { textAlign: "center" },
                    ]}
                  >
                    {item.count}
                  </Text>
                  <Text
                    style={[
                      styles.rightAlignCell,
                      styles.col15,
                      { textTransform: "uppercase" },
                    ]}
                  >
                    {item.prix} {selectedPayment?.currency}
                  </Text>
                  <Text
                    style={[
                      styles.rightAlignCell,
                      styles.col20,
                      { textTransform: "uppercase" },
                    ]}
                  >
                    {item.prix * item.count} {selectedPayment?.currency}
                  </Text>
                </View>
              ))}
            <View style={styles.tableFooter}>
              <Text style={styles.colspanCell}></Text>
              <Text style={[styles.rightAlignCell, { fontWeight: 800 }]}>
                Total:
              </Text>
              <Text
                style={[
                  styles.rightAlignCell,
                  { fontWeight: 800, textTransform: "uppercase" },
                ]}
              >
                {(selectedPayment?.amount / 100).toFixed(2)}{" "}
                {selectedPayment.currency}
              </Text>
            </View>
          </View>

          <View style={styles.footer}>
            <Text>
              Veuillez payer la facture avant la date d'échéance. Vous pouvez
              payer la facture en vous connectant à votre compte depuis notre
              portail client.
            </Text>
          </View>
        </Page>
      )}
    </Document>
  );

  return (
    <div className="h-screen">
      <Helmet>
        <title>Achats</title>
      </Helmet>
      <h1 className="poppins-bold text-3xl md:text-5xl text-gray-900 text-center">
        Mes achats
      </h1>

      <section class="relative mt-5">
        <div class="w-full max-w-7xl px-3 lg-6 space-y-2 mx-auto">
          <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table class="w-full text-sm text-left rtl:text-right text-gray-500">
              <thead class="text-gray-700 poppins-bold uppercase bg-pink-300">
                <tr>
                  <th scope="col" class="text-nowrap px-16 py-3 text-center">
                    N° facture
                  </th>
                  <th scope="col" class="text-nowrap px-6 py-3">
                    Total
                  </th>
                  <th scope="col" class="text-nowrap px-6 py-3 text-center">
                    Mode de paiement
                  </th>
                  <th scope="col" class="text-nowrap px-6 py-3">
                    Date
                  </th>
                  <th scope="col" class="text-nowrap px-6 py-3">
                    Status
                  </th>
                  <th scope="col" class="text-nowrap px-6 py-3 text-center">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr className="bg-white border-b hover:bg-gray-50">
                    <td
                      colSpan={6}
                      className="text-center py-3 poppins-semibold uppercase"
                    >
                      <span className="loading loading-spinner loading-lg"></span>
                    </td>
                  </tr>
                ) : payments.length === 0 ? (
                  <tr className="bg-white border-b hover:bg-gray-50">
                    <td
                      colSpan={6}
                      className="text-center py-3 poppins-semibold uppercase"
                    >
                      Aucun produit acheté
                    </td>
                  </tr>
                ) : (
                  payments.map((payment, index) => (
                    <tr
                      key={payment.id}
                      className="bg-white border-b hover:bg-gray-50"
                    >
                      <td className="px-16 py-3 text-center text-nowrap">
                        ECO-{payment.num_facture}
                      </td>
                      <td className="px-6 py-3 text-nowrap">
                        {(payment.amount / 100).toFixed(2)}{" "}
                        <span className="uppercase">{payment.currency}</span>
                      </td>
                      <td className="px-6 py-3 text-center text-nowrap">
                        {payment.payment_method}
                      </td>
                      <td className="px-6 py-3 text-nowrap">
                        {formatDate(payment.createdAt.seconds)}
                      </td>
                      <td className="px-6 py-3">
                        {payment.status === "succeeded" ? (
                          <div className="badge badge-success text-white text-xs text-nowrap w-full">
                            Complété
                          </div>
                        ) : payment.status === "pending" ? (
                          <div className="badge badge-warning text-white text-xs text-nowrap w-full">
                            En attente
                          </div>
                        ) : (
                          <div className="badge badge-error text-white text-xs text-nowrap w-full">
                            Réfusé
                          </div>
                        )}
                      </td>
                      <td className="px-6 py-3 flex justify-center space-x-1">
                        <button
                          className="py-1 text-blue-600 hover:text-blue-700 rounded poppins-semibold flex items-center"
                          onClick={() => showModal(payment)}
                        >
                          <IoEyeSharp size={20} />
                        </button>
                        {payment &&
                          (payment.status !== "failed" && (
                            <PDFDownloadLink
                              onClick={() => setSelectedPayment(payment)}
                              className="text-gray-400 hover:text-gray-500 py-1 rounded"
                              document={<InvoicePDF />}
                              fileName={`ECO-${payment.num_facture}.pdf`}
                            >
                              <IoDocument size={20} />
                            </PDFDownloadLink>
                          ))}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <dialog id="payment-modal" className="modal">
        <div
          class="max-w-3xl mx-auto p-6 bg-white rounded shadow-sm my-6 h-screen overflow-y-auto"
          id="invoice"
        >
          {selectedPayment && (
            <>
              <div class="grid grid-cols-2 items-center">
                <div className="flex items-center poppins-bold text-5xl text-black">
                  <img src={Logo} alt="company-logo" height="100" width="100" />
                  {/* <span>ECOKAZ</span> */}
                </div>

                <div class="text-right">
                  <p>Lallbahadoor Shastri road candos</p>
                  <p class="text-gray-500 text-sm">contact@ecokazafrica.com</p>
                  <p class="text-gray-500 text-sm mt-1">+23058555814</p>
                </div>
              </div>

              <div class="grid grid-cols-2 items-center mt-8">
                <div>
                  <h3 class="poppins-bold text-xl text-gray-800">
                    Facturer à :
                  </h3>
                  <p class="text-gray-600 text-sm">
                    {selectedPayment.address_ship}
                    <br />
                    {selectedPayment.city_ship} {selectedPayment.postal_ship},{" "}
                    {selectedPayment.country_ship}
                  </p>
                  <p class="text-gray-600 text-sm">
                    {selectedPayment.email_ship}
                  </p>
                </div>

                <div class="text-right">
                  <p class="text-sm text-gray-600">
                    N° facture:{" "}
                    <span className="poppins-semibold">
                      ECO-{selectedPayment.num_facture}
                    </span>
                  </p>
                  <p class="text-sm text-gray-600">
                    Date de facture:{" "}
                    {formatSimpleDate(selectedPayment.createdAt.seconds)}
                    <br />
                    Heure de facture:{" "}
                    {formatHeure(selectedPayment.createdAt.seconds)}
                  </p>
                </div>
              </div>

              <div class="-mx-4 mt-8 flow-root sm:mx-0">
                <table class="min-w-full">
                  <thead class="border-b border-gray-300 text-gray-900">
                    <tr>
                      <th
                        scope="col"
                        class="py-3.5 pl-4 pr-3 text-left text-sm poppins-semibold text-gray-900 sm:pl-0"
                      >
                        Produits
                      </th>
                      <th
                        scope="col"
                        class="hidden px-3 py-3.5 text-right text-sm poppins-semibold text-gray-900 sm:table-cell"
                      >
                        Quantités
                      </th>
                      <th
                        scope="col"
                        class="hidden px-3 py-3.5 text-right text-sm poppins-semibold text-gray-900 sm:table-cell"
                      >
                        Prix
                      </th>
                      <th
                        scope="col"
                        class="py-3.5 pl-3 pr-4 text-right text-sm poppins-semibold text-gray-900 sm:pr-0"
                      >
                        Montant
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedPayment.items.length > 0 &&
                      selectedPayment.items.map((item) => (
                        <tr class="border-b border-gray-200" key={item._id}>
                          <td class="max-w-0 py-2 pl-4 pr-3 text-sm sm:pl-0">
                            <div class="text-gray-900">{item.title}</div>
                            <div class="mt-1 truncate text-gray-500">
                              {item.mesure}
                            </div>
                          </td>
                          <td class="hidden px-3 py-5 text-right text-sm text-gray-500 sm:table-cell">
                            {item.count}
                          </td>
                          <td class="hidden px-3 py-5 text-right text-sm text-gray-500 sm:table-cell">
                            {item.prix}{" "}
                            <span className="uppercase">
                              {selectedPayment.currency}
                            </span>
                          </td>
                          <td class="py-5 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-0">
                            {(item.count * item.prix).toFixed(2)}{" "}
                            <span className="uppercase">
                              {selectedPayment.currency}
                            </span>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <th
                        scope="row"
                        colspan="3"
                        class="hidden pl-4 pr-3 pt-4 text-right text-sm poppins-semibold text-gray-900 sm:table-cell sm:pl-0"
                      >
                        Total
                      </th>
                      <th
                        scope="row"
                        class="pl-6 pr-3 pt-4 text-left text-sm poppins-semibold text-gray-900 sm:hidden"
                      >
                        Total
                      </th>
                      <td class="pl-3 pr-4 pt-4 text-right text-sm poppins-semibold text-gray-900 sm:pr-0">
                        {(selectedPayment.amount / 100).toFixed(2)}{" "}
                        <span className="uppercase">
                          {selectedPayment.currency}
                        </span>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <div class="border-t-2 pt-4 text-xs text-gray-500 text-center mt-16">
                Veuillez payer la facture avant la date d'échéance. Vous pouvez
                payer la facture en vous connectant à votre compte depuis notre
                portail client.
              </div>
              <div className="block md:flex justify-end md:space-x-3 mt-8">
                <button
                  className={`py-1 px-3 text-sm bg-gray-400 transition-all duration-300 rounded text-white ${
                    selectedPayment.status ==="failed" ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-500'
                  }`}
                  disabled={
                    !selectedPayment || selectedPayment.status === "failed"
                  }
                >
                  Imprimer
                </button>
                  <PDFDownloadLink
                    document={<InvoicePDF />}
                    fileName={`ECO-${selectedPayment.num_facture}.pdf`}
                  >
                    {({ blob, url, loading, error }) => (
                      <button className={`py-1 px-3 text-sm bg-blue-600 transition-all duration-300 rounded text-white ${
                        selectedPayment.status === 'failed' ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-700'
                      }`}
                        size="large"
                        disabled={selectedPayment.status === "failed"}
                      >
                        {loading ? "Téléchargement..." : "Télécharger"}
                      </button>
                    )}
                  </PDFDownloadLink>
                <form method="dialog">
                  <button className="py-1 px-3 text-sm bg-red-600 transition-all duration-300 hover:bg-red-700 rounded text-white">
                    Annuler
                  </button>
                </form>
              </div>
            </>
          )}
        </div>
      </dialog>
    </div>
  );
}

export default Achats;
